import React from "react"
import "./Premiumresidences.css"

const PremiumResidences = () => {
  return (
    <div>
      <div className="squarepremiumresidency" data-aos="fade-up"
        data-aos-duration="1000">
        <div className="squarepremiumresidency-top">
          {/* <h3>THE ONLY PREMIUM RESIDENCES IN THE TOWN</h3> */}
          <h3>PREMIUM RESIDENCES</h3>
        </div>
        <div className="squarepremiumresidency-bottom">
          <div>
            <img src="./SquarePhotos/PremiumResidences/premium3.jpeg" alt="" className="squarepremiumresidency-bottom-img" />
            <img src="./SquarePhotos/PremiumResidences/bathroom.jpeg" alt="" className="squarepremiumresidency-bottom-hover-img" />
            <p>1 Bed Room</p>
          </div>
          <div>
            <img src="./SquarePhotos/PremiumResidences/premium1.jpeg" alt="" className="squarepremiumresidency-bottom-img" />
            <img src="./SquarePhotos/PremiumResidences/bathroom.jpeg" alt="" className="squarepremiumresidency-bottom-hover-img" />
            <p>2 Bed Room</p>
          </div>
          {/* <div>
            <img src="./SquarePhotos/PremiumResidences/premium3.jpeg" alt="" className="squarepremiumresidency-bottom-img" />
            <img src="./SquarePhotos/PremiumResidences/bathroom.jpeg" alt="" className="squarepremiumresidency-bottom-hover-img" />
            <p>3 Bed Room</p>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default PremiumResidences